import React from "react"
import Img from "gatsby-image"
import { useStaticQuery } from "gatsby"
import classnames from "classnames"

const BackQuote = ({ children, isGreenbox, author }) => {
  const Images = useStaticQuery(graphql`
    query {
      quoteOpen: file(relativePath: { eq: "images/quote-open.png" }) {
        ...fragmentsFluidImage
      }

      quoteClose: file(relativePath: { eq: "images/quote-close.png" }) {
        ...fragmentsFluidImage
      }
    }
  `)
  return (
    <div
      className={classnames({
        "back-quote-outer": true,
        "back-quote-outer--green": isGreenbox,
      })}
    >
      <div
        className={classnames({
          "back-quote": true,
          "back-quote--green": isGreenbox,
        })}
      >
        <div className="back-quote__open">
          <Img
            fluid={Images.quoteOpen.childImageSharp.fluid}
            alt={children}
            title={children}
          ></Img>
        </div>
        <h3>{children}</h3>
        <div className="back-quote__close">
          <Img
            fluid={Images.quoteClose.childImageSharp.fluid}
            alt={children}
            title={children}
          ></Img>
        </div>
      </div>
      {author && <div className="back-quote__author">{author}</div>}
    </div>
  )
}

export default BackQuote
